import React from 'react';
import './RandomButton.css'; 

function RandomButton({ onSelect, dishes }) {

  if (!dishes || dishes.length === 0) {
    return null;
  }
  const handleClick = () => { 
    onSelect();
  };

  return (
    <button className="random-button" onClick={handleClick}>
      随机吃什么？
    </button>
  );
}

export default RandomButton;